﻿import common = require("../../../common");
import Vue from 'vue';
import Component from 'vue-class-component'
import HotEditableFormManager = require("./HotEditableFormManager");
import utilities = require("../../utilities");

declare function __getHotEditableMessageComponentTemplate(): string;

@Component({
    props: {
        initId: String,
        initName: String,
        initFieldName: String,
        initClass: String,
        initIconClass: String,
        initTextClass: String,
        initMessage: String,
        initMessageType: String,
        initAutoCloseOnFormAction: Boolean,
        initMode: String,
    }
})
class HotEditableMessageComponent extends Vue {
    initId: string;
    initName: string;
    initFieldName: string;
    initClass: string;
    initIconClass: string;
    initTextClass: string;
    initMessage: string;
    initMessageType: string;
    initAutoCloseOnFormAction: boolean;
    initMode: string;

    idElement: string;
    elementName: string;
    fieldName: string;
    cssClass: string;
    iconClass: string;
    textClass: string;
    autoCloseOnFormAction: boolean;
    mode: string;
    message: string;
    messageType: common.HotEditableMessageTypes;

    _formManagerParent: HotEditableFormManager;//NOTE: Doit undefined initialement car il est definie dans le "beforeCreate"

    static tagName = "hoteditablemessage";
    static prepareMarkup(element: HTMLElement) {

        if (!element)
            throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";

        element.removeAttribute("hot-editable");
        element.setAttribute("hot-editable-cloak", "");

        const newOuterHtml = element.outerHTML
            .replace('<span ', '<' + this.tagName + ' ')
            .replace('<div ', '<' + this.tagName + ' ')
            .replace('<p ', '<' + this.tagName + ' ')
            .replace(' id=', ' init-id=')
            .replace(' name=', ' init-name=')
            .replace(' field-name=', ' init-field-name=')
            .replace(' mode=', ' init-mode=')
            .replace(' message=', ' init-message=')
            .replace(' message-type=', ' init-message-type=')
            .replace(' class=', ' init-class=')
            .replace(' icon-class=', ' init-icon-class=')
            .replace(' text-class=', ' init-text-class=')
            .replace(' auto-close-on-form-action=', ' v-bind:init-auto-close-on-form-action=');

        element.outerHTML = newOuterHtml;
    }

    data() {
        const id = this.initId || "Field_" + utilities.createGuid('N');
        const mode = common.HotEditableFormMessageModes[this.initMode] || common.HotEditableFormMessageModes.unknown;

        const messageType: common.HotEditableMessageTypes = this.initMessageType
            ? common.HotEditableMessageTypes[this.initMessageType] || function () { throw "[UPA::HotEditableMessageComponent] L'attribut 'message-type' (init-message-type) est requis et doit etre valide (enum::HotEditableMessageTypes)." }()
            : common.HotEditableMessageTypes.unknown;

        const o = {
            idElement: id,
            elementName: this.initName || id,
            fieldName: this.initFieldName || '',
            cssClass: this.initClass || 'mod-hot-editable-message',
            iconClass: this.initIconClass || 'mhem-icon',
            textClass: this.initTextClass || 'mhem-text',
            autoCloseOnFormAction: this.initAutoCloseOnFormAction === true,
            mode: mode,
            message: this.initMessage || null,
            messageType: messageType
        };

        return o;
    }

    created() {
    }

    beforeCreate() {
        this._formManagerParent = (this.$parent as any).formManager.registerMessage(this);
        this.$options.template = __getHotEditableMessageComponentTemplate();
    }

    mounted() {
        (this.$el as Element).removeAttribute("hot-editable-cloak");
    }

    update(message?: string, messageType?: common.HotEditableMessageTypes) {
        this.message = message || null;
        if (messageType)
            this.messageType = messageType;
        return this;
    }
    clearMessage() {
        this.message = null;
        return this;
    }
    clearMessageType() {
        this.messageType = common.HotEditableMessageTypes.unknown;
        return this;
    }
}

export = HotEditableMessageComponent;